import { Component } from '@theme/component';

/** Enhances the native disclosure; signup remains usable without JavaScript. */
class HenryPumpkinOffer extends Component {
  requiredRefs = ['details', 'trigger'];
  #abort;

  connectedCallback() {
    super.connectedCallback();
    this.#abort?.abort();
    this.#abort = new AbortController();
    const { signal } = this.#abort;
    document.addEventListener('pointerdown', this.#closeOutside, { signal });
    document.addEventListener('keydown', this.#handleKeydown, { signal });
    this.refs.trigger.addEventListener('click', this.#openExistingSignup, { signal });
    this.#showFormResult();
  }

  updatedCallback() {
    super.updatedCallback();
    this.#showFormResult();
  }

  disconnectedCallback() {
    this.#abort?.abort();
    super.disconnectedCallback();
  }

  /** Close the offer and restore keyboard focus to its trigger. */
  closeOffer() {
    this.refs.details.open = false;
    this.refs.trigger.focus({ preventScroll: true });
  }

  #closeOutside = (event) => {
    if (event.target instanceof Node && !this.contains(event.target)) this.refs.details.open = false;
  };

  #openExistingSignup = (event) => {
    const newsletter = document.querySelector('henry-newsletter');
    if (typeof newsletter?.openDialog !== 'function') return;
    event.preventDefault();
    this.refs.details.open = false;
    newsletter.openDialog();
  };

  #handleKeydown = (event) => {
    if (event.key === 'Escape' && this.refs.details.open) this.closeOffer();
  };

  #showFormResult() {
    // Only reopen a server-rendered result for this form, never on a timer.
    if (this.querySelector('[data-offer-result]') && window.location.hash === `#${this.querySelector('form')?.id}`) {
      this.refs.details.open = true;
    }
  }
}

if (!customElements.get('henry-pumpkin-offer')) customElements.define('henry-pumpkin-offer', HenryPumpkinOffer);
